import { render } from "./exportleads.vue?vue&type=template&id=970812ee"
import script from "./exportleads.vue?vue&type=script&lang=js"
export * from "./exportleads.vue?vue&type=script&lang=js"

import "./exportleads.vue?vue&type=style&index=0&id=970812ee&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__